import { createI18nNamespace } from '../i18n';

export const personaListCopy = createI18nNamespace('modules.personaList');

export type PersonaListCopyKey =
  | 'eyebrow'
  | 'title'
  | 'description'
  | 'emptyTitle'
  | 'emptyDescription'
  | 'loading'
  | 'unauthorizedTitle'
  | 'unauthorizedDescription'
  | 'errorTitle'
  | 'create.action'
  | 'create.title'
  | 'create.description'
  | 'create.contractTitle'
  | 'create.contractDescription'
  | 'create.personaName'
  | 'create.personaNamePlaceholder'
  | 'create.displayName'
  | 'create.displayNamePlaceholder'
  | 'create.descriptionLabel'
  | 'create.descriptionPlaceholder'
  | 'create.agentType'
  | 'create.provider'
  | 'create.providerPlaceholder'
  | 'create.model'
  | 'create.modelPlaceholder'
  | 'create.guardrailTitle'
  | 'create.guardrailDescription'
  | 'create.close'
  | 'create.cancel'
  | 'create.submit'
  | 'create.submitting'
  | 'create.success'
  | 'create.nameRequired'
  | 'create.conflict'
  | 'create.error'
  | 'lifecycle.title'
  | 'lifecycle.description'
  | 'lifecycle.persona'
  | 'lifecycle.openActions'
  | 'lifecycle.unavailableBadge'
  | 'lifecycle.unavailableAction'
  | 'lifecycle.action'
  | 'lifecycle.state'
  | 'lifecycle.safety'
  | 'lifecycle.clone'
  | 'lifecycle.cloneState'
  | 'lifecycle.cloneSafety'
  | 'lifecycle.archive'
  | 'lifecycle.archiveState'
  | 'lifecycle.archiveSafety'
  | 'lifecycle.delete'
  | 'lifecycle.deleteState'
  | 'lifecycle.deleteSafety'
  | 'actions.more'
  | 'actions.moreFor'
  | 'actions.menuLabel'
  | 'actions.open'
  | 'actions.openHelper'
  | 'actions.clone'
  | 'actions.archive'
  | 'actions.enable'
  | 'actions.disable'
  | 'actions.statusUnavailable'
  | 'actions.archivedTerminal'
  | 'openWorkbench'
  | 'noPlatforms'
  | 'unavailable'
  | 'partialData'
  | 'meta.kind'
  | 'meta.kindValue'
  | 'meta.source'
  | 'meta.route'
  | 'meta.mode'
  | 'meta.modeValue'
  | 'status.personas'
  | 'status.liveSessions'
  | 'status.platforms'
  | 'status.partial'
  | 'status.distinctPlatforms'
  | 'status.partialEvidence'
  | 'table.name'
  | 'table.agent'
  | 'table.platforms'
  | 'table.sessions'
  | 'table.skills'
  | 'table.workDirectory'
  | 'table.actions'
  | 'table.detail'
  | 'table.sessionsValue'
  | 'redirect.eyebrow'
  | 'redirect.title'
  | 'redirect.description'
  | 'redirect.persona'
  | 'redirect.canonicalRoute'
  | 'redirect.mode'
  | 'redirect.modeValue'
  | 'redirect.openWorkbench';
